module.exports = __webpack_public_path__ + "img/中国科学院遥感与数字地球研究所.5e3ea31a.png";